import { workdeskFilterConstants } from 'store/constants';
import { Statuses } from 'store/models/Statuses';
import {
  WorkdeskFilter,
  WorkdeskFilterSortBy,
  WorkdeskFilterWithPrevStoreState,
} from 'store/models/WorkdeskFilter';
import { EachSortBy } from 'store/models/workdesk-tickets/workdesk-tickets.interface';

const initialSortBy: EachSortBy[] = [
  {
    field: 'receivedTime',
    dir: 'DESC',
  },
];

export const defaultInitialState = {
  selectedInboxes: {},
  selectedStatus: 'SI_READY',
  statusesStartAt: {},
  selectedTicketType: Statuses.defaultTicketType,
  // order of sort matters!
  sortBy: initialSortBy,
  workdeskFilterInLsOnInit: false,
  searchValues: {},
};

const wdFilterFromLocal = WorkdeskFilter.getFromLocalStorage();

const initialState: WorkdeskFilterWithPrevStoreState = wdFilterFromLocal
  ? {
      cur: { ...defaultInitialState, ...wdFilterFromLocal },
      prev: null,
      hadCalledApi: false,
      beforeLoadMainPageSelectedInboxes: {},
    }
  : {
      cur: defaultInitialState,
      prev: null,
      hadCalledApi: false,
      beforeLoadMainPageSelectedInboxes: {},
    };

// const initialState: WorkdeskFilterStoreState = {
//   selectedInboxes: {},
//   selectedStatus: 'SI_READY',
//   statusesStartAt: {},
//   selectedTicketType: 'ALL',
//   // order of sort matters!
//   sortBy: initialSortBy,
//   workdeskFilterInLsOnInit: false,
// };

export const workdeskFilter = (
  state = initialState,
  action: { type: string; payload: any },
) => {
  const { payload = {} } = action;
  const {
    address,
    status,
    ticketType,
    field,
    dir,
    startAt,
    searchValues,
  } = payload;
  switch (action.type) {
    case workdeskFilterConstants.SET_SEARCH_VALUES:
      return {
        ...state,
        cur: { ...state.cur, searchValues },
        prev: state.cur,
        hadCalledApi: false, // had called api for this search
      };
    case workdeskFilterConstants.SET_HAD_CALLED_API:
      return {
        ...state,
        hadCalledApi: action.payload.hadCalledApi,
      };
    case workdeskFilterConstants.HAD_WORKDESK_FILTER_IN_LS_ON_INIT:
      return {
        ...state,
        cur: {
          ...state.cur,
          workdeskFilterInLsOnInit:
            action.payload.workdeskFilterInLsOnInit,
        },
        prev: state.cur,
      };
    case workdeskFilterConstants.TOGGLE_SORT_BY_OF_FIELD:
      return {
        ...state,
        cur: {
          ...state.cur,
          sortBy: new WorkdeskFilterSortBy(
            state.cur.sortBy,
          ).singleSortToggleSortDirOfField(field, dir),
        },
        prev: state.cur,
      };
    case workdeskFilterConstants.TOGGLE_SELECTED_INBOX:
      return {
        ...state,
        cur: {
          ...state.cur,
          selectedInboxes: {
            ...state.cur.selectedInboxes,
            [address]: !state.cur.selectedInboxes[address],
          },
        },
        prev: state.cur,
      };
    case workdeskFilterConstants.SET_SELECTED_INBOXES:
      return {
        ...state,
        cur: {
          ...state.cur,
          selectedInboxes: action.payload.addresses.reduce(
            (acc, add) => ({
              ...acc,
              [add]: action.payload.value,
            }),
            {},
          ),
        },
        prev: state.cur,
      };
    case workdeskFilterConstants.TOGGLE_SELECTED_STATUS:
      return {
        ...state,
        cur: { ...state.cur, selectedStatus: status },
        prev: state.cur,
      };
    case workdeskFilterConstants.SELECT_STATUS_TYPE:
      return {
        ...state,
        cur: { ...state.cur, selectedTicketType: ticketType },
        prev: state.cur,
      };
    case workdeskFilterConstants.CHANGE_START_AT_FOR_STATUS:
      if (!status) throw Error(`need status`);
      if (!ticketType) throw Error(`also need ticketType`);
      return {
        ...state,
        cur: {
          ...state.cur,
          statusesStartAt: {
            ...state.cur.statusesStartAt,
            [status]: {
              ...(state.cur.statusesStartAt[status] || {}),
              [ticketType]: startAt,
            },
          },
        },
        prev: state.cur,
      };
    case workdeskFilterConstants.CACHE_BEFORE_LOAD_SELECTED_INBOXES:
      return {
        ...state,
        beforeLoadMainPageSelectedInboxes:
          state.cur?.selectedInboxes ||
          defaultInitialState.selectedInboxes,
      };
    case workdeskFilterConstants.RESTORE_FROM_BEFORE_LOAD_SELECTED_INBOXES:
      // in case load directly from url then hit back to workdesk page
      // case unselect all on the workdesk -> go to main -> come back to workdesk it will auto select the main's inbox for selected inboxes
      let newSelectedInboxes =
        state.beforeLoadMainPageSelectedInboxes;
      if (
        !Object.keys(newSelectedInboxes).length ||
        Object.values(newSelectedInboxes).every(
          (val) => val === false,
        )
      ) {
        newSelectedInboxes = state.cur.selectedInboxes;
      }
      if (!Object.keys(newSelectedInboxes).length) {
        newSelectedInboxes = defaultInitialState.selectedInboxes;
      }
      return {
        ...state,
        cur: {
          ...state.cur,
          selectedInboxes: newSelectedInboxes,
        },
      };
    default:
      return state;
  }
};
